import { Box, SimpleGrid } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import { constructYupSchema } from './helpers';
import {
  FormCustomError,
  FormItem,
  FormikOnChangeObserver,
} from './components';
import React from 'react';

export const FormBuilder = ({
  formRef,
  config = [],
  initialValues = {},
  onSubmit = undefined,
  errorMessage = '',
  showCustomError = false,
  observFunc = undefined,
  isObserveEnabled = false,
  formContainerProps = {},
  hasFormChild = false,
  FormChild = () => <></>,
}) => {
  if (!config || config.length === 0) return null;

  const formSchema = constructYupSchema(config);

  return (
    <Box pos="relative" {...formContainerProps}>
      <Formik
        enableReinitialize
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={onSubmit ? onSubmit : () => {}}
      >
        {(formik) => (
          <Form>
            {showCustomError && (
              <FormCustomError formik={formik} errorMessage={errorMessage} />
            )}
            <SimpleGrid columns={1} spacingY="1px">
              {config.map((item, index) => (
                <React.Fragment key={index}>
                  <FormItem field={item} formik={formik} />
                </React.Fragment>
              ))}
            </SimpleGrid>
            {isObserveEnabled && (
              <FormikOnChangeObserver
                onChange={observFunc ? observFunc : () => {}}
                delay={0}
              />
            )}
            {hasFormChild && <FormChild />}
          </Form>
        )}
      </Formik>
    </Box>
  );
};
